import { create } from "zustand";
import zukeeper from "zukeeper";

const initState = {
  filter: null,
  bidResult: null,
  bidPage: 1,
  procureResult: null,
  procurePage: 1,
  planResult: null,
  planPage: 1,
};

const useBidStore = create(
  zukeeper((set) => ({
    filter: null,
    setFilter: (newFilter) => {
      set(() => ({
        filter: newFilter,
      }));
    },
    bidResult: null,
    setBidResult: (newResult) => {
      set(() => ({
        bidResult: newResult,
      }));
    },
    bidPage: 1,
    setBidPage: (newPage) => {
      set(() => ({
        bidPage: newPage,
      }));
    },
    procureResult: null,
    setProcureResult: (newResult) => {
      set(() => ({
        procureResult: newResult,
      }));
    },
    procurePage: 1,
    setProcurePage: (newPage) => {
      set(() => ({
        procurePage: newPage,
      }));
    },
    planResult: null,
    setPlanResult: (newResult) => {
      set(() => ({
        planResult: newResult,
      }));
    },
    planPage: 1,
    setPlanPage: (newPage) => {
      set(() => ({
        planPage: newPage,
      }));
    },
    reset: () => set(initState),
  }))
);
window.store = useBidStore;
export default useBidStore;
